import styled, { css } from 'styled-components';
import { Button, Form, Select } from 'antd';

import { tangerineGradient, tangerineGradientRevert } from '../../styles';

const FItem = Form.Item;
const { Option } = Select;


export const FormItem = styled(FItem)`
  margin-bottom: 20px;
  label {
    color: ${props => props.theme.colors.fontSilverDark};
  }
  .ant-form-item-label {
    line-height: 2;
  }
  .ant-form-explain {
    padding-top: 10px;
  }
`;

export const SelectS = styled(Select)`
  font-size: 14px;
`;
export const StyledOption = styled(Option)`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 100px;
  padding: 10px;
`;

export const Title = styled.h3`
  font-weight: normal;
  font-size: 20px;
  line-height: 24px;
  margin-bottom: 16px;
  text-align: center;
  color: ${props => props.theme.colors.black};
`;

export const SubTitle = styled.h4`
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;  
  margin-bottom: 16px;
  text-align: center;
  color: ${({ theme }) => theme.colors.fontSilverPrimary};
`;

export const HistoryWrapper = styled.div`
  margin-top: 7px;
  text-align: left;
  
  ${({ showBottomBorder, theme }) => showBottomBorder && css`
    padding-bottom: 7px;
    border-bottom: 1px solid ${theme.colors.whiteLilac};
  `};

  > div:first-child {
    font-size: 13px;
    margin-bottom: 7px;
    color: ${({ theme }) => theme.colors.fontSilverLight};
  }
`;

export const ButtonWrapper = styled.div`
  text-align: right;
`;

export const ButtonSave = styled(Button)`
  margin-top: 15px;
  ${tangerineGradient};
  color: ${props => props.theme.colors.white};
  width: 150px;
  height: 30px;  
  border: none;
  &:hover,
  &:focus {
    ${tangerineGradientRevert};
  }
`;

export const FieldWrapper = styled.div`
  position: relative;
`;



// WEBPACK FOOTER //
// ./src/modals/manage-talents-modal/styled-components.js